import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Toggle = ({ state, handleToggle }) => (
  <ToggleWrapper>
    <ToggleBox>
      <ToggleInput
        type="checkbox"
        checked={state}
        onChange={handleToggle}
      />
      <ToggleSlider>
        <ToggleCircle $checked={state} />
      </ToggleSlider>
    </ToggleBox>
  </ToggleWrapper>
);

Toggle.propTypes = {
  state: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired,
  handleToggle: PropTypes.func.isRequired,
};

export default memo(Toggle);

const ToggleWrapper = styled.div`
  display: flex;
`;

const ToggleBox = styled.div`
  position: relative;
  display: inline-block;
  width: 80px;
  height: 34px;
`;

const ToggleCircle = styled.span`
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: ${(props) => props.theme.main.iconDefault};
  transition: .4s;
  border-radius: 50%;
  transform: ${(props) => (props.$checked ? 'translateX(46px)' : 'translateX(0)')};
`;

const ToggleSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${(props) => props.theme.main.togglePassive};
  transition: .4s;
  border-radius: 34px;
`;

const ToggleInput = styled.input`
    opacity: 0;
    width: 80px;
    height: 34px;
    position: relative;
    z-index: 10;
  :checked + ${ToggleSlider} {
    background-color: ${(props) => props.theme.main.toggleActive};
  }
  :focus + ${ToggleSlider} {
    box-shadow: ${(props) => props.theme.effects.boxShadow};
  }
`;
